// extracted by mini-css-extract-plugin
export default {"container":"widget-area_container__SXgA1","personalise":"widget-area_personalise__ucQX0","list":"widget-area_list__bbAXn"};